// extracted by mini-css-extract-plugin
export default {"image":"ConstellationDecoration_image__46JLg"};